import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import api from "@/lib/api";

export function PolicyDialog({ open, onClose, onAccept }) {
  const [pages, setPages] = useState(null);

  useEffect(() => {
    if (open && !pages) api.get("/settings").then((r) => setPages(r.data?.pages || {})).catch(() => setPages({}));
  }, [open, pages]);

  const sections = [
    { k: "terms", title: "Kushtet e Përdorimit" },
    { k: "privacy", title: "Politika e Privatësisë" },
  ];

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-sm rounded-2xl max-h-[85vh] flex flex-col" data-testid="policy-dialog">
        <DialogHeader>
          <DialogTitle>Kushtet dhe Privatësia</DialogTitle>
        </DialogHeader>
        <div className="flex-1 min-h-0 overflow-y-auto overscroll-contain pr-1 space-y-4" data-testid="policy-scroll">
          {sections.map((s) => (
            <section key={s.k}>
              <h3 className="text-sm font-bold text-slate-900 mb-1">{s.title}</h3>
              <p className="text-sm text-slate-600 whitespace-pre-wrap leading-relaxed">
                {pages === null ? "Duke ngarkuar..." : pages[s.k]?.value || "Përmbajtja nuk është shtuar ende."}
              </p>
            </section>
          ))}
        </div>
        <Button data-testid="policy-accept-btn" onClick={() => { onAccept(); onClose(); }} className="w-full shrink-0 rounded-xl h-11 bg-emerald-600 hover:bg-emerald-700">
          Pranoj
        </Button>
      </DialogContent>
    </Dialog>
  );
}
